let delegate = null;
function setDelegate(d) {
  delegate = d;
}
function getDelegate() {
  return delegate;
}
function use(...rest) {
  return delegate.use(...rest);
}
function saveLayout(...rest) {
  return delegate.saveLayout(...rest);
}
function renameLayout(...rest) {
  return delegate.renameLayout(...rest);
}
function deleteLayout(...rest) {
  return delegate.deleteLayout(...rest);
}
function setPreferredLayout(...rest) {
  return delegate.setPreferredLayout(...rest);
}
function getLayoutFrom(...rest) {
  return delegate.getLayoutFrom(...rest);
}
function getVersionFrom(...rest) {
  return delegate.getVersionFrom(...rest);
}
function getVersionValue(...rest) {
  return delegate.getVersionValue(...rest);
}
export default {
  setDelegate,
  getDelegate,
  use,
  saveLayout,
  renameLayout,
  deleteLayout,
  setPreferredLayout,
  getLayoutFrom,
  getVersionFrom,
  getVersionValue
};